var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayListIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "playlistIcon",
    width: 36,
    height: 31,
    viewBox: "0 0 36 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.1368C0 9.58456 0.447715 9.13684 1 9.13684H25.1738C25.7261 9.13684 26.1738 9.58456 26.1738 10.1368V12.7053C26.1738 13.2575 25.7261 13.7053 25.1738 13.7053H0.999999C0.447714 13.7053 0 13.2575 0 12.7053V10.1368ZM0 1C0 0.447715 0.447715 0 1 0H25.1738C25.7261 0 26.1738 0.447715 26.1738 1V3.56842C26.1738 4.12071 25.7261 4.56842 25.1738 4.56842H0.999999C0.447714 4.56842 0 4.12071 0 3.56842V1ZM0 19.2737C0 18.7214 0.447715 18.2737 1 18.2737H15.6561C16.2083 18.2737 16.6561 18.7214 16.6561 19.2737V21.8421C16.6561 22.3944 16.2083 22.8421 15.6561 22.8421H1C0.447715 22.8421 0 22.3944 0 21.8421V19.2737ZM24.963 16.9183C24.2967 16.5114 23.4419 16.991 23.4419 17.7718V29.257C23.4419 30.0292 24.2799 30.51 24.9466 30.1203L34.5553 24.5025C35.2084 24.1207 35.2174 23.18 34.5718 22.7858L24.963 16.9183Z",
    fill: "url(#paint0_linear_105_1758)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_105_1758",
    x1: 54,
    y1: 15.5,
    x2: 23.3434,
    y2: -20.1012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayListIcon);
export default __webpack_public_path__ + "static/media/playListIcon.7936aa81.svg";
export { ForwardRef as ReactComponent };